const Game = {
  name: 'palm-island',

  setup: () => ({}),

  moves: {},

  turn: {}
};

export default Game;
